import { t } from 'ttag'
import { useMemo } from 'react'

import { SLB } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Option, OptionGroup } from '@h2/components/containers/optionGroup'
import { StudentIcon } from '@h2/components/icons/student'
import { ProgramIcon } from '@h2/components/icons/program'
import { FamilyMemberIcon } from '@h2/components/icons/familyMember'
import { Card } from '@h2/common/components/card'

import { props } from './props'
import { ContentWrap, OptionBody } from './components'

import { Navigator } from '../highlights/navigator'
import { Back } from '../back'
import { Controls } from '../controls'

const resets = {
  educatorType: null,
  counselorType: null,
  k12EducatorType: null,
  k12Population: null,
  k12Program: null
}
const NavigatorType = ({ inDialog, properties, validate, renderPanel }) => {
  const navigatorType = useMemo(() => properties.navigatorType, [
    properties.navigatorType
  ])

  return (
    <Card inDialog={inDialog}>
      <Card.Highlight color={SLB}>
        <Navigator />
      </Card.Highlight>
      <Card.Content>
        <ContentWrap>
          <Heading level="2" align="center" mb="12px">
            {t`What type of Navigator are you?`}
          </Heading>
          <Text align="center">{t`Let us know the stage of education you are in.`}</Text>
          <OptionGroup
            gap="15px"
            value={navigatorType}
            onClick={value => validate({ navigatorType: value, ...resets })}>
            <Option value="educator">
              <OptionBody>
                <StudentIcon size="large" />
                <span className="flex">
                  <span>{t`Educator`}</span>
                  <span>{t`Working with my students to build their career plans.`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="counselor">
              <OptionBody>
                <ProgramIcon size="large" />
                <span className="flex">
                  <span>{t`Career Counselor`}</span>
                  <span>{t`They are attending adult education`}</span>
                </span>
              </OptionBody>
            </Option>
            <Option value="family">
              <OptionBody>
                <FamilyMemberIcon size="large" />
                <span className="flex">
                  <span>{t`Family Member`}</span>
                  <span>{t`They are attending adult education`}</span>
                </span>
              </OptionBody>
            </Option>
          </OptionGroup>
          <Controls>
            <Back onClick={() => renderPanel('basic')} />
          </Controls>
        </ContentWrap>
      </Card.Content>
      <Card.Detour>
        <Back onClick={() => renderPanel('basic')} />
      </Card.Detour>
    </Card>
  )
}

NavigatorType.propTypes = { ...props }

export { NavigatorType }
